<script>
    import AppIcon from "./AppIcon.svelte";

    export let active = false;
    export let size = 'normal';

</script>
<div class:active={ active }>
<AppIcon icon="{ active ? 'flash-solid' : 'flash' }" {size}/>
<!--    <AppIcon icon="flash-solid" {size}/>-->
</div>
<style>
    .active {
        color: #03a9f4;
    }
</style>